module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "编号",
      "width": "100",
      "prop": "code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "限制",
      "width": "100",
      "prop": "xz"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "统计",
      "width": "100",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "信息",
      "width": "100",
      "prop": "msg"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4853e458"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 647
// module chunks = 1